<template>
  <SubMenuTabTemplate :icon="routeIcon(node)" :text="routeDisplayName(node)" :disabled="!jobHasOrder"
    :disabledHint="$t('servicesystem.common_objects.fallbackterms.no_order_on_job')" :hide="hide" :to="{ name: node.name, params: $route.params }">
  </SubMenuTabTemplate>
</template>


<script>
import SubMenuTabTemplate from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_template.vue";

export default {
  name: "SubMenuTab_OrderDependent",
  props: {
    node: Object,
    hide: Boolean,
  },
  components: {
    SubMenuTabTemplate,
  },

  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {
  },

  computed: {
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
    jobHasOrder() {
      return this.JobDetails?.JobTypeId != 3 && !!this.JobDetails?.OrderId;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>